<div style="height: 100%; margin: 0 12px; overflow: auto;">
  <div style="display: flex; justify-content: space-around; margin: 5px;">
    <div>Current Document</div>
    <div>Compare To Document</div>
  </div>
  <div style="height:100%; overflow: visible;" *ngIf="outputHtml$ | async as outputHtml">
    <div style="position: relative;" [innerHTML]="outputHtml | safeHtml"></div>
  </div>
</div>
